import { FC } from "react";

import { isSubmissionLate } from "../helpers";

import { SUBMISSION_ID_QUERY_PARAM } from "components/constants";
import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { PageTabVariant } from "providers/DocViewProvider";
import { useCapabilities } from "store/capability-hooks";
import { pageSelectors, submissionSelectors } from "store/selectors";
import { useObjectSelector } from "store/store-hooks";
import { useQueryParam } from "utils/routing";

export type InstructorLateSubmissionBannerProps = {
  pageId: string;
  selectedTabVariant?: PageTabVariant;
};

export const InstructorLateSubmissionBanner: FC<InstructorLateSubmissionBannerProps> = ({
  pageId,
  selectedTabVariant,
}) => {
  const { canAuthorSection } = useCapabilities();
  const page = useObjectSelector((s) => pageSelectors.selectById(s, pageId), ["due_at"]);
  const submissionId = useQueryParam(SUBMISSION_ID_QUERY_PARAM);
  const submission = useObjectSelector(
    (s) => submissionSelectors.selectById(s, submissionId),
    ["created_at"],
  );
  const submissionIsLate = isSubmissionLate(submission, page?.due_at);

  const showInstructorLateSubmissionBanner =
    submissionIsLate &&
    canAuthorSection &&
    (selectedTabVariant === "student_submission" || submission);

  if (!showInstructorLateSubmissionBanner) {
    return null;
  }

  return (
    <Banner className="page-block-width" kind="warning">
      {t("warning.late_submission_alert_instructor")}
    </Banner>
  );
};
